//SET_USERNAME
export const setUserNameAction = (userName) => ({
    type : 'SET_USERNAME',
    userName
});

//SET_SEARCH_TIMESTAMP
export const setSearchTimeStampAction = (searchTimestamp) => ({
    type : 'SET_SEARCH_TIMESTAMP',
    searchTimestamp
});


// WEBPACK FOOTER //
// ./src/Actions/userInfo.js